import React, { useState, useEffect } from "react";
import PlusRound from "../../icons/PlusRound";
import axios from "axios";
import AddressPopup from "../../checkout/components/AddressPopup";
import addressHTML, { HTML } from "../../../components/addressHTML";

const AddressBook = (props) => {
  const [addresses, setAddresses] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [countries, setCountries] = useState([]);
  const [currentAddress, setCurrentAddress] = useState(null);

  useEffect(() => {
    init();
  }, []);

  const closeAddressPopup = () => {
    setOpenPopup(false);
  };

  const openAddressPopup = (e) => {
    e.preventDefault();
    setOpenPopup(true);
    return false;
  };

  const openEditAddressPopup = (address) => {
    setOpenPopup(true);
    setCurrentAddress(address);
  };

  const makeDefaultAddress = (address) => {
    axios
      .post(props.base + "/make-default", {
        address: address.id,
      })
      .then((response) => {
        setAddresses(response.data.addresses);
        setCountries(response.data.countries);
      });
  };

  const removeAddress = (address) => {
    axios
      .post(props.base + "/remove-address", {
        address: address.id,
      })
      .then((response) => {
        setAddresses(response.data.addresses);
        setCountries(response.data.countries);
      });
  };

  const init = () => {
    axios.get(props.base + "/address-feed").then((response) => {
      setAddresses(response.data.addresses);
      setCountries(response.data.countries);
    });
  };

  const saveAddress = (address) => {
    axios.post(props.base + "/address-save", address).then((response) => {
      setOpenPopup(false);
      setCurrentAddress(null);
      setAddresses(response.data.addresses);
    });
  };

  return (
    <React.Fragment>
      <div className="account-page__address">
        <div className="account-page__add-address">
          <a
            href="#"
            onClick={openAddressPopup}
            className="btn btn--hollow btn--not-bg-icon"
          >
            <PlusRound /> Add new address
          </a>
        </div>
        <div className="address-item">
          <div className="address-item__content">
            <h5 className="address-section__title">Saved address</h5>
            <div className="address-item__grid">
              {addresses.map((address) => {
                return (
                  <address
                    key={`address_${address.id}`}
                    className="address-item__address"
                  >
                    <p
                      dangerouslySetInnerHTML={{
                        __html: addressHTML(address, HTML),
                      }}
                    />

                    {address.is_default && (
                      <span className="address-item__primary">
                        Primary Address
                      </span>
                    )}

                    <span
                      onClick={(e) => {
                        e.preventDefault();
                        openEditAddressPopup(address);
                        return false;
                      }}
                      className="address-item__make-primary"
                    >
                      Edit
                    </span>

                    {!address.is_default && (
                      <span
                        className="address-item__make-primary"
                        onClick={() => {
                          makeDefaultAddress(address);
                        }}
                      >
                        Make primary
                      </span>
                    )}

                    {!!address.can_remove && (
                      <span
                        onClick={(e) => {
                          e.preventDefault();
                          removeAddress(address);
                          return false;
                        }}
                        className="address-item__make-danger"
                      >
                        Remove
                      </span>
                    )}
                  </address>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {openPopup && (
        <AddressPopup
          address={currentAddress}
          countries={countries}
          parent={{ closeAddressPopup, saveAddress }}
        />
      )}
    </React.Fragment>
  );
};

export default AddressBook;
